<template>
  <div class="container">
    <AddEditTournament v-if="addEdit" />
    <template v-else>
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <input
                    type="text"
                    class="form-control"
                    v-model="keyword"
                    :placeholder="$t('gpool.tournaments_search')"
                  />
                </div>
                <div class="col-5"></div>
                <div class="col-2">
                  <button
                    class="btn btn-success"
                    @click="setAddEdit(true)"
                  >
                    {{ $t('gpool.add') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-body">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>{{ $t('gpool.tournaments_table_status') }}</th>
                    <th>{{ $t('gpool.tournaments_table_name') }}</th>
                    <th>{{ $t('gpool.tournaments_table_dates') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tour in tournaments">
                    <td>{{ tour.id }}</td>
                    <td>
                      <span
                        class="badge badge-soft-success"
                        v-if="tour.status == 'continues'"
                      >
                        {{ $t('gpool.tournaments_status_ongoing') }}
                      </span>
                      <span
                        class="badge badge-soft-warning"
                        v-else-if="tour.status == 'planned'"
                      >
                        {{ $t('gpool.tournaments_status_planned') }}
                      </span>
                      <span
                        class="badge badge-soft-secondary"
                        v-else-if="tour.status == 'finished'"
                      >
                        {{ $t('gpool.tournaments_status_finished') }}
                      </span>
                    </td>
                    <td>{{ tour.name }}</td>
                    <td>
                      {{ tour.start_date | date }} - {{ tour.end_date | date }}
                    </td>
                    <td>
                      <button
                        class="btn btn-info"
                        @click="editTournament({ site_id, tour_id: tour.id })"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button
                        class="btn btn-danger"
                        @click="deleteTournament({ site_id, tour_id: tour.id })"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import AddEditTournament from '@/components/AddEditTournament'
import { mapGetters, mapActions, mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'SiteTournaments',
  components: {
    AddEditTournament
  },
  filters: {
    date: function (value) {
      if (!value) return ''
      return moment(value).format('DD.MM.YYYY HH:mm:ss')
    }
  },
  computed: {
    ...mapState('tournament', ['addEdit']),
    ...mapGetters('tournament', ['tournaments']),
    keyword: {
      get() {
        return this.$store.state.tournament.keyword
      },
      set(value) {
        this.$store.state.tournament.keyword = value
      }
    },
    site_id() {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions('game', ['getGames']),
    ...mapActions('tournament', [
      'getTournaments',
      'setAddEdit',
      'editTournament',
      'deleteTournament'
    ])
  },
  async mounted() {
    await this.getGames()
    this.getTournaments(this.$route.params.id)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/SiteTournaments.vue